<template>
    <div>
        <el-dialog
            title="发放风币"
            :visible.sync="dialogCoinVisible"
            :append-to-body="true"
            width="400px"
            :center="true"
            top="200px"
            :close-on-click-modal="false"
            :before-close="() => closeCoinDialog()"
        >
            <el-form
                :model="CoinForm"
                :rules="rules"
                ref="CoinForm"
                label-width="100px"
            >
                <el-form-item label="风币数量" prop="num">
                    <el-input-number
                        v-model="CoinForm.num"
                        :min="-999999"
                        :max="999999"
                        :step-strictly="true"
                    ></el-input-number>
                </el-form-item>
                <div style="text-align: center;color: #FF0000;font-weight: bold;">
                    <div>温馨提示：发放的金币于次日05:30到账</div>
                    <div>发放记录及到账情况可在【荣誉积分-抽奖记录】中查看</div>
                </div>
            </el-form>
            <div slot="footer">
                <el-button type="success" plain @click="submit('CoinForm')" >发 放</el-button>
                <el-button plain @click="closeCoinDialog()">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { UserGiveCoinRequest } from '@/network/user.js'

export default {
    name:'',
    data(){
        return {
            CoinForm: {
                num: 1
            },
            rules: {
                num: [
                    {
                        required: true,
                        message: '请填写风币数量',
                        trigger: 'blur',
                    }
                ]
            },
        }
    },
    computed:{},
    methods:{
        closeCoinDialog() {
            this.CoinForm = {
                num: 1
            }
            this.$emit('ExitCoinDialog')
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                this.CoinForm.user_id = this.id
                UserGiveCoinRequest(this.CoinForm)
                    .then((s) => {
                        if (s.status === 0) {
                            this.$message.success('风币发放成功，次日05点30到账!')
                            this.closeCoinDialog()
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        }
    },
    filters:{},
    props:{
        dialogCoinVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        id: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    created(){},
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{}
}
</script>

<style lang='less' scoped>
</style>